export enum SearchFilterNamesEnum {
  OPEN_NOW = 'openNow',
  OPEN_WEEKEND = 'openWeekend',
}

export enum SearchStateFieldsEnum {
  CAREPROVIDER_UNIT_TYPE = 'caregiverUnitTypeUrlPath',
  CARE_SERVICE_TYPE = 'careServiceTypeUrlPath',
  SYMPTOM = 'symptomUrlPath',
  PLACE = 'placeUrlPath',
  FREE = 'freeSearchTerm',
  LOCATION = 'locationSearch',
  OPEN_NOW = 'openNow',
  OPEN_WEEKEND = 'openWeekend',
  LATITUDE = 'lat',
  LONGITUDE = 'lon',
  PAGE = 'page',
  BOOKING_TYPE = 'bookingType',
}

export enum SearchPayloadConditionsFieldsEnum {
  CAREPROVIDER_UNIT_TYPE = 'caregiverUnitTypeUrlPath',
  CARE_SERVICE_TYPE = 'careServiceTypeUrlPath',
  SYMPTOM = 'symptomUrlPath',
  PLACE = 'placeUrlPath',
  FREE = 'freeSearchTerm',
  OPEN_NOW = 'openNow',
  OPEN_WEEKEND = 'openWeekend',
  BOOKING_TYPE = 'bookingType',
  CUSTOMER_FEATURE_TYPE = 'customerFeatureType',
}

export enum SortConditionsFieldsEnum {
  ES_SCORE = 1,
}

export enum SearchFilterCustomerFeatureTypeValueEnum {
  LISTA_DIG = 'lista-dig-direct',
}

export enum SearchSuggestTypesEnum {
  CAREPROVIDER_UNIT_TYPE = 'CaregiverUnitType',
  CARE_SERVICE_TYPE = 'CareServiceType',
  SYMPTOM = 'Symptoms',
  PLACE = 'Place',
  CAREPROVIDER_UNIT = 'Mottagning',
  CAREPROVIDER = 'CareProvider',
}

export enum SearchLabelEnum {
  CAREPROVIDER_UNIT_TYPE = 'Yrkeskategori',
  CARE_SERVICE_TYPE = 'Behandling',
  SYMPTOM = 'Symptom',
  PLACE = 'Ort',
  CAREPROVIDER_UNIT = 'Mottagning',
  CAREPROVIDER = 'Vårdgivare',
}

export enum SearchPlaceLabelEnum {
  COUNTY = '',
  MUNICIPALITY = 'Kommun/Tätort',
  DISTRICT = 'Stadsdel',
  DEFAULT = 'Ort',
}

export enum SearchPlaceTypeNameEnum {
  MUNICIPALITY = 'Municipality',
  DISTRICT = 'District',
  COUNTY = 'County',
}

export enum SearchResultsStateEnum {
  LOADING = 'loading',
  LOADED = 'loaded',
  NO_RESULTS = 'no-results',
}

